module.exports = __webpack_public_path__ + "img/dd.8a913283.svg";